import React, { useState, lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  Navigate,
} from "react-router-dom";
import ReactGA from "react-ga4";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { LanguageContext } from "./store/language-context";
import Navbar from "./Components/Navbar/Navbar";
import LazyRender from "./Components/LazyRender";
const Page = lazy(() => import("./Components/Page"));
const LearningAsAlmsgiving = lazy(
  () => import("./LearningAsAlmsgiving/LearningAsAlmsgiving"),
);
const Gallery = lazy(() => import("./VideoGallery/Gallery"));
const Biography = lazy(() => import("./Resume/Biography"));
const Home = lazy(() => import("./Views/Home"));
const Footer = lazy(() => import("./Components/Footer/Footer"));
const NotFound = lazy(() => import("./Components/NotFound/NotFound"));
const LoginPage = lazy(() => import("./admin/Views/Login/LoginPage"));
const Dashboard = lazy(() => import("./admin/Views/Dashboard/Dashboard"));
const ContactUs = lazy(() => import("./Components/ContactUs/ContactUs"));
const Test = lazy(() => import("./Components/Home/Carousel/Test"));
// const Ip = "http://localhost/raed_back/";
const Ip = "https://raedcharafeddine.net/raed_back/";

ReactGA.initialize("G-G3S98KS8HQ");

const Layout = ({ children }) => {
  const location = useLocation();
  const isLoginPage =
    location.pathname === "/admin" ||
    location.pathname === "/Admin" ||
    location.pathname === "/dashboard" ||
    location.pathname === "/Dashboard" ||
    location.pathname === "/admin/" ||
    location.pathname === "/Admin/";

  return (
    <>
      {!isLoginPage && <Navbar Ip={Ip} />}
      {children}
      {!isLoginPage && (
        <LazyRender height="300px">
          <Footer Ip={Ip} />
        </LazyRender>
      )}
    </>
  );
};

const App = () => {
  const ProtectedRoute = ({ children }) => {
    const isAuthenticated = localStorage.getItem("isAuthenticated");

    // console.log('Is Authenticated:', isAuthenticated);
    if (isAuthenticated === null) {
      return <Navigate to="/" />;
    }
    return isAuthenticated === "true" ? children : <Navigate to="/Admin" />;
  };

  const [isLang, setIsLang] = useState("En");

  const handleUpdateLang = (value) => setIsLang(value);

  const ctxValue = {
    isLang,
    changeLang: handleUpdateLang,
  };

  return (
    <Suspense fallback={<div className="lazy-fallback">Loading...</div>}>
      <LanguageContext.Provider value={ctxValue}>
        <Router>
          {/* <Navbar/> */}
          <Layout>
            <Routes>
              <Route path="/" element={<Home Ip={Ip} />} />
              <Route path="/Page" element={<Page Ip={Ip} />} />
              <Route
                path="/LearningAsAlmsgiving"
                element={<LearningAsAlmsgiving Ip={Ip} />}
              />
              <Route path="/VideoGallery" element={<Gallery Ip={Ip} />} />
              <Route path="/Resume" element={<Biography Ip={Ip} />} />
              <Route path="/Admin" element={<LoginPage Ip={Ip} />} />
              <Route path="/Contact" element={<ContactUs Ip={Ip} />} />
              <Route path="/Test" element={<Test Ip={Ip} />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard Ip={Ip} />
                  </ProtectedRoute>
                }
              />
              {/* <Route path="/dashboard" element={<Dashboard Ip={Ip} />} /> */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
          {/* <Footer /> */}
        </Router>
      </LanguageContext.Provider>
    </Suspense>
  );
};

export default App;
